// extracted by mini-css-extract-plugin
export default {"popover":"ScenarioOptionsMenu-module__popover__lPA4B","menu":"ScenarioOptionsMenu-module__menu__fobnW"};